// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1RcrW","footer":"ReportModalFilter_footer__2o5y-"};